export enum CalenderEventType {
  EXPIRING_TODAY,
  EXPIRING_IN_A_MONTH,
  BINDING_TODAY,
  EFFECTIVE_TODAY,
}

export interface CalendarEvent {
  type: CalenderEventType
  name: string
  start: string
  end?: Date
  color?: string
  otherParams?: {
    [key: string]: unknown;
  }
}
